module.exports = __webpack_public_path__ + "images/retailer-margins-blue-d4461ddd.svg";